module.exports = [
    "send your data to the server",
    "validate the data",
    "apply preprocessing",
    "generate results",
    "sending you back the measurements"
]